import { ApiResponse } from '../../types';

const apiUrl: string = import.meta.env.VITE_ADMIN_URL;

export const save = (token: string, values: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...values }),
    };

    fetch(
      apiUrl + "/sucursal/save",
      requestOptions
    )
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAll = (token: string): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    fetch(
      apiUrl + "/sucursal/obtener",
      requestOptions
    )
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        console.error("Error al obtener empleados: ", err);
        reject(err);
      });
  });
};
